import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ISessionState {
  session: string;
}

const initialState: ISessionState = {
  session: ''
};

export const virtualAssistant = createSlice({
  name: 'virtualAssistant',
  initialState,
  reducers: {
    saveSession: (state, action: PayloadAction<ISessionState>) => {
      state.session = action.payload.session;
    }
  }
});

export const { saveSession } = virtualAssistant.actions;
export const virtualAssistantReducer = virtualAssistant.reducer;
